import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { SUPPORTED_LANGUAGES } from '../i18n/config';

export function LanguageSwitcher({ compact = false }) {
    const { i18n } = useTranslation();
    const currentLang = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

    const changeLang = (code) => {
        try { localStorage.setItem('nikayofx_lang_manual', '1'); } catch { /* ignore */ }
        i18n.changeLanguage(code);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors"
                    style={{
                        backgroundColor: 'var(--background-elevated)',
                        border: '1px solid var(--border-subtle)',
                        color: 'var(--text-primary)',
                    }}
                    data-testid="language-switcher-trigger"
                >
                    <Globe className="w-4 h-4" style={{ color: 'var(--primary-color)' }} />
                    {!compact && (
                        <span className="text-sm font-medium hidden sm:inline">
                            {currentLang.native}
                        </span>
                    )}
                    <span className="text-base">{currentLang.flag}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="w-48"
                style={{
                    backgroundColor: 'var(--background-surface)',
                    borderColor: 'var(--border-default)',
                }}
            >
                {SUPPORTED_LANGUAGES.map((lang) => {
                    const isActive = lang.code === i18n.language;
                    return (
                        <DropdownMenuItem
                            key={lang.code}
                            onClick={() => changeLang(lang.code)}
                            className="cursor-pointer flex items-center justify-between gap-3"
                            data-testid={`language-option-${lang.code}`}
                        >
                            <div className="flex items-center gap-3">
                                <span className="text-lg">{lang.flag}</span>
                                <div>
                                    <p className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
                                        {lang.native}
                                    </p>
                                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
                                        {lang.name}
                                    </p>
                                </div>
                            </div>
                            {isActive && (
                                <Check className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--primary-color)' }} />
                            )}
                        </DropdownMenuItem>
                    );
                })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
